import './join-button.scss';

type JoinButtonProps = {
  link?: string | null;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
};

// Renders nothing when the link is missing, null, or blank.
const JoinButton = ({ link, className = '', onClick }: JoinButtonProps) => {
  const href = link?.trim();

  if (!href) {
    return null;
  }

  return (
    <a
      className={`join-button ${className}`.trim()}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
    >
      Join
    </a>
  );
};

export default JoinButton;
